import { j as jsxRuntimeExports } from "./doenetml-jBZLIepG.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-TOMteQ16.js";
const mdash = React__default.memo(function Ndash(props) {
  let { SVs } = useDoenetRenderer(props, false);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "—" });
});
export {
  mdash as default
};
